import { addBackToTop } from 'vanilla-back-to-top';

addBackToTop({
  backgroundColor: '#ff6b08',
  innerHTML:
    '<svg viewBox="0 0 24 24"><path d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"/></svg>',
  textColor: '#ffffff',
});
